import { useMutation } from '@tanstack/react-query'
import { httpClient } from '../../shared/api/httpClient'
import { useAstreaEnvironment } from '../../shared/hooks/useAstreaEnvironment'

export function useLawsuitOwnerQuery() {
  const { urlAstreaPath } = useAstreaEnvironment()

  const mutation = useMutation({
    mutationFn: async ({ tenantId, lawsuitNumber }) => {
      const url = `${urlAstreaPath}/api/v2/dev/case/find-by`
      const response = await httpClient.get(url, { params: { tenantId, lawsuitNumber } })
      return response.data
    },
  })

  return {
    getOwner: mutation.mutateAsync,
    ownerName: mutation.data?.ownerName,
    responsibleName: mutation.data?.responsibleName,
    jobId: mutation.data?.jobId,
    sharingType: mutation.data?.sharingType,
    teamName: mutation.data?.teamName,
    isLoading: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
  }
}

export default useLawsuitOwnerQuery
